import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="页面未找到 - 征途国际官方下载"
        description="您访问的页面不存在，请返回征途国际首页继续浏览。"
      />
      <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="text-8xl font-heading font-bold text-primary-500 mb-4">404</div>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            页面未找到
          </h1>
          <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-md">
            您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页继续浏览。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </div>
    </>
  );
}